import React from 'react';
import './AtacamaMapSection.css';
import { HandDrawnButton } from '../shared/HandDrawnButton/HandDrawnButton';

// Import Figma assets - correct paths
const mapBackgroundImage = "/assets/figma/e81ab367ef65525aad1480d1faddeb5f7050ad91.png";
const logoGroup = "/assets/figma/02e739d1381b52040b39c56d406b7d00be8af740.svg";
const logoGroup1 = "/assets/images/our-story/0501557fb03c945e93b7f590ca32f7a6f081cb88.svg";
const markerArrow = "/assets/images/our-story/a33ba1312186de6cc92a2a3b035bfed60a30305c.svg";
const dividerLine = "/assets/figma/0e35e273a925e300bc2b2a9ed6748868626e8c0d.svg";

interface AtacamaMapSectionProps {
  property?: string;
  title?: string;
  content?: {
    address?: string;
    fromTitle?: string;
    fromDescription?: string;
    borderTitle?: string;
    borderDescription?: string;
  };
}

export const AtacamaMapSection: React.FC<AtacamaMapSectionProps> = ({ 
  property = "atacama",
  title,
  content
}) => {
  // Get property-specific content
  const getContentForProperty = () => {
    switch (property.toLowerCase()) {
      case 'iguazu':
        return {
          title: title || "Getting to Awasi Iguazú",
          address: content?.address || "Puerto Iguazú (IGR) - 20km / 30 min from Awasi",
          fromTitle: content?.fromTitle || "FROM BUENOS AIRES",
          fromDescription: content?.fromDescription || "Fly to Puerto Iguazú (IGR) - 20km / 30 min from Awasi. FROM SAO PAULO OR RIO DE JANEIRO: Fly to Foz de Iguaçu (IGU) - 17 km / 45 min from Awasi incl. border crossing. Awasi includes private transfers from and to Puerto Iguazú (IGR) or Foz de Iguaçu (IGU) airports, in accordance with our check in & check out times.",
          borderTitle: content?.borderTitle || "OTHER AIRPORTS",
          borderDescription: content?.borderDescription || "Our team can suggest different alternatives for transfers from other places. Other airports: Posadas (POS): 310 km / 4:00 hs"
        };
      case 'mendoza':
        return {
          title: title || "Getting to Awasi Mendoza",
          address: content?.address || "Agrelo, Lujan de Cuyo, Mendoza, Argentina",
          fromTitle: content?.fromTitle || "FROM MENDOZA INTERNATIONAL AIRPORT",
          fromDescription: content?.fromDescription || "The lodge is only 40 minutes' drive from Mendoza International Airport and 25 minutes' drive from Mendoza city. Drive South of Mendoza city on Route 40 and take route 7 towards Chile. 4 km straight west and then turn left on Calle Costa Flores. The lodge is 2 km from route 7 (dust road).",
          borderTitle: content?.borderTitle || "NEARBY ATTRACTIONS",
          borderDescription: content?.borderDescription || "Mendoza city: 25 minutes\nAndes Mountains: 1 hour\nWineries: Walking distance"
        };
      case 'santa-catarina':
      case 'santacatarina':
        return {
          title: title || "Getting to Awasi Santa Catarina",
          address: content?.address || "Governador Celso Ramos, Santa Catarina, Brazil",
          fromTitle: content?.fromTitle || "FROM FLORIANÓPOLIS INTERNATIONAL AIRPORT",
          fromDescription: content?.fromDescription || "The closest airport is Florianópolis International Airport – Hercílio Luz (FLN), with daily flights from the main Brazilian capitals and international connections via São Paulo and Rio de Janeiro. The journey to the lodge takes around 1h15 by road. It is also possible to organize private transfers or arrival by helicopter upon request.",
          borderTitle: content?.borderTitle || "NEARBY ATTRACTIONS",
          borderDescription: content?.borderDescription || "Florianópolis: 1h15 by road\nTrês Ilhas archipelago: Views from lodge\nEmerald Coast beaches: Walking distance"
        };
      case 'atacama':
      default:
        return {
          title: title || "Getting to Awasi Atacama",
          address: content?.address || "Tocopilla 551, San Pedro de Atacama, Antofagasta, Chile",
          fromTitle: content?.fromTitle || "FROM SANTIAGO DE CHILE",
          fromDescription: content?.fromDescription || "Fly to Calama (CJC) 100 km / 1:30 hs from Awasi. Awasi includes private transfers from and to Calama in accordance to our check in & check out times. Our team can suggest different alternatives for transfers from other places.",
          borderTitle: content?.borderTitle || "NEARBY LAND BORDERS",
          borderDescription: content?.borderDescription || "Bolivia: Hito Cajón (45 km)\nArgentina: Paso de Jama (155 km)"
        };
    }
  };
  
  const mapContent = getContentForProperty();
  
  return (
    <div className="atacama-map-section" data-name="map" id="node-622_19471">
      <div className="atacama-map-container">
        {/* Map Background Container */}
        <div className="atacama-map-background-container" id="node-622_18447">
          <div 
            className="atacama-map-background"
            id="node-622_18444"
            style={{ backgroundImage: `url('${mapBackgroundImage}')` }}
          />
          
          {/* Atacama Logo Marker */}
          <div className="atacama-logo-marker" data-name="atacama_logo" id="node-632_29213">
            <div className="atacama-logo-container">
              <div className="atacama-logo-layer" data-name="Layer 1" id="node-632_29214">
                <div className="atacama-logo-group-wrapper" data-name="Group" id="node-632_29215">
                  <div className="atacama-logo-detail-group" data-name="Group" id="node-632_29216">
                    <img
                      alt=""
                      className="atacama-logo-detail-img"
                      src={logoGroup}
                    />
                  </div>
                  <div className="atacama-logo-main-group" data-name="Group" id="node-632_29224">
                    <img
                      alt=""
                      className="atacama-logo-main-img"
                      src={logoGroup1}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Marker Arrow */}
          <div className="atacama-marker-arrow">
            <div className="atacama-arrow-container" id="node-632_29235">
              <img
                alt=""
                className="atacama-arrow-img"
                src={markerArrow}
              />
            </div>
          </div>
        </div>

        {/* Information Panel */}
        <div className="atacama-info-panel" id="node-622_19470">
          <div className="atacama-info-background" id="node-622_18449" />
          
          <div className="atacama-info-title" id="node-788_54268">
            <p>Getting to Awasi Atacama</p>
          </div>
          
          <div className="atacama-info-content" id="node-788_54269">
            <div className="atacama-info-sections" id="node-788_54270">
              <div className="atacama-info-main-section" id="node-788_54271">
                <div className="atacama-info-item" id="node-788_54272">
                  <div className="atacama-info-label" id="node-788_54273">
                    <p>Address</p>
                  </div>
                  <div className="atacama-info-text" id="node-788_54274">
                    <p>
                      Tocopilla 551, San Pedro de Atacama, Antofagasta, Chile
                    </p>
                  </div>
                </div>
                
                <div className="atacama-info-item" id="node-788_54275">
                  <div className="atacama-info-label" id="node-788_54276">
                    <p>
                      FROM SANTIAGO DE CHILE
                    </p>
                  </div>
                  <div className="atacama-info-text" id="node-788_54277">
                    <p>Fly to Calama (CJC) 100 km / 1:30 hs from Awasi.  Awasi includes private transfers from and to Calama in accordance to our check in & check out times. Our team can suggest different alternatives for transfers from other places.</p>
                  </div>
                </div>
                
                <div className="atacama-divider" id="node-788_54278">
                  <img
                    alt=""
                    className="atacama-divider-line"
                    src={dividerLine}
                  />
                </div>
              </div>
              
              <div className="atacama-info-item" id="node-788_54279">
                <div className="atacama-info-label" id="node-788_54280">
                  <p>NEARBY LAND BORDERS</p>
                </div>
                <div className="atacama-info-text" id="node-788_54281">
                  <p>Bolivia: Hito Cajón (45 km)</p>
                  <p>Argentina: Paso de Jama (155 km)</p>
                </div>
              </div>
            </div>
            
            <div className="atacama-info-buttons" id="node-788_54285">
              <HandDrawnButton
                text="CONTACT US"
                variant={property as any}
                color="off-white"
                size="normal"
                animation="stroke-to-fill"
              />
              <HandDrawnButton
                text="LEARN MORE"
                variant={property as any}
                color="white"
                size="normal"
                animation="fill-to-stroke"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AtacamaMapSection;